import { IconButton, Stack, TableBody, TableContainer, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ListHeader } from './ListHeader'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { ListItem } from './ListItem'
import { onGetSurveyReport } from 'redux/actions'
import AppLoader from '@crema/core/AppLoader'
import PropTypes from 'prop-types'
import DialogDetail from './DetailDialog'
import AppsPagination from '@crema/core/AppsPagination'
import { Download } from '@mui/icons-material'
import { grey } from '@mui/material/colors'
import { StyledTable } from 'shared/components/Table'
import TableEmptyResult from 'shared/components/Table/TableEmptyResult'

const ListSurvey = ({ handleExportSurvey }) => {
    const { loading } = useSelector(state => state.common);
    const { listReport } = useSelector(state => state.survey);
    const dispatch = useDispatch()
    const [page, setPage] = useState({
        value: 0,
        refresh: false,
    })
    const [dialog, setDialog] = useState({
        id: '',
        toggle: false
    })

    const handleOpenDialog = (id) => {
        setDialog({
            id: id,
            toggle: true
        })
    }

    const handleCloseDialog = () => {
        setDialog({
            id: '',
            toggle: false
        })
    }

    const onPageChange = (event, value) => {
        setPage({
            refresh: true,
            value: value
        });
    };

    useEffect(() => {
        if (page.refresh) {
            dispatch(onGetSurveyReport(page.value + 1))
            setPage({ ...page, refresh: false })
        }
    }, [page]);

    return (
        <Stack position={'relative'}>
            {
                loading && !dialog.toggle && <AppLoader />
            }

            <Stack flex={1} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                <AppsPagination
                    sx={{
                        paddingRight: 2,
                        paddingLeft: 2,
                        '& .MuiToolbar-root': {
                            paddingLeft: 0,
                        },
                        '& .MuiTablePagination-actions': {
                            marginLeft: 0,
                            '& .MuiButtonBase-root': {
                                padding: 2,
                            },
                        },
                    }}
                    count={listReport?.count === undefined ? 0 : listReport?.count}
                    rowsPerPage={10}
                    page={page.value}
                    labelDisplayedRows={({ from, to, count }) =>
                        ` ${from}-${to} dari ${count}`
                    }
                    onPageChange={onPageChange}
                />

                {
                    listReport !== null ? (
                        <Tooltip arrow placement='bottom' title={'Download hasil survei'}>
                            <IconButton
                                onClick={handleExportSurvey}
                                sx={{ width: 35, height: 35, borderRadius: '100%', padding: 1, backgroundColor: grey[100], color: grey[700] }}
                            >
                                <Download />
                            </IconButton>
                        </Tooltip>
                    ) : null
                }
            </Stack>

            <Stack sx={{ height: '100%', overflow: 'auto' }}>
                <TableContainer className="custom-scrollbar">
                    <StyledTable stickyHeader aria-label="customize table">
                        <ListHeader />
                        <TableBody>
                            {
                                listReport !== null && listReport?.result.map((data, i) => (
                                    <ListItem
                                        index={i}
                                        key={data.id}
                                        data={data}
                                        no={page.value}
                                        handleOpenDialog={() => handleOpenDialog(data.id)}
                                    />
                                ))
                            }
                            <TableEmptyResult list={listReport?.result} />
                        </TableBody>
                    </StyledTable>
                </TableContainer>
            </Stack>

            <DialogDetail open={dialog.toggle} handleClose={handleCloseDialog} id={dialog.id} />
        </Stack>
    )
}

ListSurvey.propTypes = {
    handleExportSurvey: PropTypes.func
}

export default ListSurvey